import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

const TestimonialForm = () => {
  const { id } = useParams(); // Accessing URL params to know if it's an 'Add' or 'Edit'
  const navigate = useNavigate();
  
  const [operation, setOperation] = useState('Add');
  const [heading, setHeading] = useState('');
  const [description, setDescription] = useState('');
  const [reviewBy, setReviewBy] = useState('');
  
  useEffect(() => {
    // If there's an ID, it's an 'Edit' operation
    if (id) {
      setOperation('Edit');
      fetchTestimonial(id);
    }
  }, [id]);

  // Fetch the testimonial if editing
  const fetchTestimonial = async (id) => {
    try {
      const response = await fetch(`https://your-api-url.com/website/testimonial/${id}`);
      const data = await response.json();
      setHeading(data.heading);
      setDescription(data.description);
      setReviewBy(data.reviewby);
    } catch (err) {
      console.error("Error fetching testimonial:", err);
      Swal.fire('Error', 'Could not fetch the testimonial.', 'error');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = { heading, description, reviewby: reviewBy };

    try {
      const method = operation === 'Edit' ? 'PUT' : 'POST';
      const response = await fetch(`https://your-api-url.com/website/testimonial/save`, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      if (result.success) {
        Swal.fire('Success', `${operation} Testimonial was successful!`, 'success');
        navigate('/website/testimonial'); // Redirect to the testimonials list
      } else {
        Swal.fire('Error', result.message || 'There was an issue saving the testimonial.', 'error');
      }
    } catch (err) {
      Swal.fire('Error', 'There was an issue with the server.', 'error');
    }
  };

  return (
    <div className="page-container mt-5">
      <div className="">
        <div className="panel panel-default with-rounded-corner with-shadow">
          <div className="panel-heading border-0">
            <h4 className="panel-title">{operation} Testimonial</h4>
          </div>

          <div className="panel-body">
            <form onSubmit={handleSubmit} className="stdform" encType="multipart/form-data">
              <input type="hidden" name="id" value={id || ''} />

              <div className="row">
                <div className="form-group col-md-6">
                  <label>Review By</label>
                  <input
                    type="text"
                    className="form-control"
                    name="reviewby"
                    value={reviewBy}
                    onChange={(e) => setReviewBy(e.target.value)}
                    placeholder="Enter Review By"
                  />
                </div>

                <div className="form-group col-md-12">
                  <label>Description</label>
                  <textarea
                    className="form-control"
                    name="description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    placeholder="Enter Description"
                    rows="5"
                  />
                </div>

                <div className="form-group col-md-12">
                  <button type="submit" className="btn btn-primary">
                    {operation} Testimonial
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary mx-2"
                    onClick={() => navigate('/website/testimonial')}
                  >
                    Back
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>

        {/* Scroll to top button */}
        <a href="#" data-click="scroll-top" className="btn-scroll-top fade">
          <i className="ti-arrow-up"></i>
        </a>
      </div>
    </div>
  );
};

export default TestimonialForm;
